import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-header" }, "Recibo da sessão")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "list-group list-group-flush" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-paragraph" }, "CPF", -1)
const _hoisted_6 = {
  key: 0,
  class: "text-subtitle"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-subtitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-receipt me-2" }),
  /*#__PURE__*/_createTextVNode("Visualizar recibo")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-subtitle" }, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_FileUploader = _resolveComponent("FileUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", {
          class: _normalizeClass(["list-group-item d-flex justify-content-between align-items-center", { 'border-0': !_ctx.item.receipt }])
        }, [
          _hoisted_5,
          (_ctx.item?.user?.document_number)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.item?.user?.document_number), 1))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.item?.receipt)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleReceipt && _ctx.handleReceipt(...args))),
              class: "list-group-item d-flex justify-content-between align-items-center border-0 cursor-pointer"
            }, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Button, {
        label: _ctx.item?.receipt ? ' Remover recibo' : 'Anexar recibo',
        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.item?.receipt ? _ctx.handleRemoveReceipt() : _ctx.openFileUploader(_ctx.inputId)
        )),
        outline: !!_ctx.item.receipt,
        fullWidth: "",
        leftIcon: _ctx.item?.receipt ? '' : 'fa-solid fa-plus-circle',
        loading: _ctx.uploading
      }, null, 8, ["label", "outline", "leftIcon", "loading"]),
      _createVNode(_component_FileUploader, {
        onFileUploaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleUploadFile($event))),
        inputId: _ctx.inputId,
        hiddenInput: true
      }, null, 8, ["inputId"])
    ])
  ]))
}